import { __generator } from "tslib";
import { put, call, select, takeLatest } from 'redux-saga/effects';
import { partial } from 'lodash-es';
import { Canvas } from '@marvelapp/easel-client';
import * as actionTypes from '../constants/actionTypes';
import * as actionCreators from '../actionCreators';
import { getProjectNumericID } from '../selectors/project';
import { getCurrentScreen } from '../selectors/screen';
import { getEaselConfig, getColorMode } from '../selectors/handoff';
import { getDefaultCodeLang } from '../selectors/code';
import configureEasel from '../utils/handoff/configureEasel';
var actions = [
    actionTypes.LOAD_CANVAS_STARTING,
    actionTypes.SET_CURRENT_LANG,
    actionTypes.SET_COLOR_MODE,
];
export default function loadCode() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions, function () {
                    var lang, colorMode, easelConfig, projectID, currentScreen, canvasClient_1, easelResponse, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, select(function (state) { return state.code.currentLang; })];
                            case 1:
                                lang = _a.sent();
                                if (!!lang) return [3 /*break*/, 3];
                                return [4 /*yield*/, select(getDefaultCodeLang)];
                            case 2:
                                lang = _a.sent();
                                _a.label = 3;
                            case 3: return [4 /*yield*/, select(getColorMode)];
                            case 4:
                                colorMode = _a.sent();
                                return [4 /*yield*/, select(getEaselConfig)];
                            case 5:
                                easelConfig = _a.sent();
                                configureEasel(easelConfig);
                                return [4 /*yield*/, select(getProjectNumericID)];
                            case 6:
                                projectID = _a.sent();
                                return [4 /*yield*/, select(getCurrentScreen)];
                            case 7:
                                currentScreen = _a.sent();
                                if (!currentScreen.canvasID) {
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, put(actionCreators.loadCodeStart())];
                            case 8:
                                _a.sent();
                                _a.label = 9;
                            case 9:
                                _a.trys.push([9, 13, , 15]);
                                return [4 /*yield*/, call(partial(Canvas.load, projectID, currentScreen.canvasID))];
                            case 10:
                                canvasClient_1 = _a.sent();
                                return [4 /*yield*/, call(function () {
                                        return canvasClient_1.fetchCode(lang, colorMode);
                                    })];
                            case 11:
                                easelResponse = _a.sent();
                                return [4 /*yield*/, put(actionCreators.loadCodeDone(lang, easelResponse))];
                            case 12:
                                _a.sent();
                                return [3 /*break*/, 15];
                            case 13:
                                err_1 = _a.sent();
                                return [4 /*yield*/, put(actionCreators.loadCodeFailed(lang, err_1))];
                            case 14:
                                _a.sent();
                                return [3 /*break*/, 15];
                            case 15: return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
